var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.75a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.811 19.716 2.405-2.405-.926-1.658c.151-.302.282-.614.391-.934L20.5 14.2v-3.4l-1.819-.519c-.11-.32-.24-.632-.391-.934l.927-1.658-2.406-2.405-1.658.926a7.492 7.492 0 0 0-.934-.391L13.7 4h-3.4l-.519 1.819c-.32.11-.632.24-.934.391l-1.658-.926-2.405 2.405.926 1.658a7.488 7.488 0 0 0-.391.934L3.5 10.8v3.4l1.819.519c.11.32.24.632.391.934l-.926 1.658 2.405 2.405 1.658-.926c.302.151.614.282.934.391L10.3 21h3.4l.519-1.819c.32-.11.632-.24.934-.391l1.658.927Z",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSettings;